<template>
<div>
    <div class="w-100 h-100">
        <Nav @rolname="rolname" />
    </div>
    <div class="">
        <div class="w-100">
            <div class="justify-content-center p-5 d-block d-lg-flex" id="div_conte2">
                <div id="div_conte" class="col-lg-4 col-12 m-3 bg-secondary bg-opacity-10" v-if="cpShowRolesAsis.length > 0">
                    <div class="text-white">
                        <div class="text-center py-4 px-3" id="scroll">
                            <div class="row">
                                <h4 class="text-dark fw-bold">MÓDULO DE GESTIÓN ASISTENCIAL</h4>
                            </div>
                            <div id="contenedorPadre" class="row d-flex justify-content-center">
                                <div v-for="(item1, index1) in cpShowRolesAsis" :key="index1" class="col-md-8">
                                    <div class="divInterior">
                                        <button class="div-rol-asis col m-2 p-2 text-white fw-bold" @click="mtdSelectRol(item1.role.id, item1.role.name)">
                                            {{ item1.role.name }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="div_conte" class="col-lg-4 col-12 m-3 bg-secondary bg-opacity-10" v-if="cpShowRolesAdmi.length > 0">
                    <div class="text-white">
                        <div class="text-center py-4 px-3" id="scroll">
                            <div class="row">
                                <h4 class="text-dark fw-bold">MÓDULO DE GESTIÓN ADMINISTRATIVO</h4>
                            </div>
                            <div id="contenedorPadre" class="row d-flex justify-content-center">
                                <div v-for="(item2, index2) in cpShowRolesAdmi" :key="index2" class="col-md-8">
                                    <div class="divInterior">
                                        <button class="div-rol-admi col m-2 p-2 text-white fw-bold" @click="mtdSelectRol(item2.role.id, item2.role.name)">
                                            {{ item2.role.name }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="div_conte" class="col-lg-4 col-12 m-3 bg-secondary bg-opacity-10" v-if="cpShowRolesGest.length > 0">
                    <div class="text-white">
                        <div class="text-center py-4 px-3" id="scroll">
                            <div class="row">
                                <h4 class="text-dark fw-bold">MÓDULO DE GESTIÓN GESTIONAL</h4>
                            </div>
                            <div id="contenedorPadre" class="row d-flex justify-content-center">
                                <div v-for="(item3, index3) in cpShowRolesGest" :key="index3" class="col-md-8">
                                    <div class="divInterior">
                                        <button class="div-rol-gest col m-2 p-2 text-white fw-bold" @click="mtdSelectRol(item3.role.id, item3.role.name)">
                                            {{ item3.role.name }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Nav from "../../components/Asistencial/Nav.vue";
export default {
    name: "v-rol",
    components: {
        Nav,
    },
    data() {
        return {
            rolname: '',
        }
    },
    props: {
        dataRoles: [],
        dataRolesAsis: [],
        dataRolesAdmi: [],
        dataRolesGest: [],
        rol_id: null
    },
    computed: {
        cpShowRolesAsis() {
            //const dataRolesAsis = [3, 5, 6, 9, 10, 11, 15];
            const dataRolesAsis = [3, 11];
            //   return this.dataRoles.filter(rol => dataRoles.includes(rol.role.id));
            return this.dataRoles.filter(rol => {

                return dataRolesAsis.includes(rol.role.id) &&
                    !(this.rol_id === 6 && rol.role.id === 6) &&
                    !(this.rol_id === 10 && rol.role.id === 10);
            });
        },
        cpShowRolesAdmi() {
            //const dataRolesAdmi = [1, 2, 4, 7, 12, 13, 14];
            const dataRolesAdmi = [1, 17, 19, 15];
            return this.dataRoles.filter(rol => dataRolesAdmi.includes(rol.role.id));
        },
        cpShowRolesGest() {
            const dataRolesGest = [16];
            return this.dataRoles.filter(rol => dataRolesGest.includes(rol.role.id));
        }
    },
    methods: {
        mtdSelectRol: function (id, name_rol) {
            this.$emit("mtdSelectRol", id, name_rol,this.rol_id);
            this.rolname = name_rol;
        },

    },
};
</script>
